// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"ac49ef27","239":"6a53d3b4","732":"d181d2a3"}[chunkId] + ".chunk.js";
};